/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';
import { isEmpty } from '@ember/utils';

const AttributeBasedScheduledDayOffset = BaseValidator.extend({
  validate(value, options, model) {
    if (isEmpty(model.recurringSchedule) || model.recurringSchedule.calendarBased) {
      return true;
    }

    let dayOffset = model.recurringSchedule.dayOffset;
    if (isEmpty(dayOffset)) {
      return 'Please choose a valid offset';
    }

    return true;
  },
});

AttributeBasedScheduledDayOffset.reopenClass({
  getDependentsFor() {
    return ['model.recurringSchedule', 'model.recurringSchedule.dayOffset'];
  },
});

export default AttributeBasedScheduledDayOffset;
